/*

Class for generating a orgAdmin

https://www.hl7.org/fhir/person.html

{
  "state" : "<code>" // active || pending || archive || delete
  "orgId" : { Reference(Organization) }, // Organization that is the custodian of the patient record
  "userId" : { String }
  "name" : [{ HumanName }], // A name associated with the patient
  "sex" : "<code>", // male | female | transmale | transfemale | other | unknown
  "gender" : "<code>", // male | female | nonbinary | other | unknown
  "birthdate" : "<date>", // The date of birth for the individual
  "telecom" : [{ ContactPoint }], // A contact detail for the individual
  "userType" : "<code>" // patient || providerAP || providerLP || orgAdmin || person
}

*/

// Import libraries
// const Joi = require('joi'); // Reenable when orgAdmin specific validation

// Import variables
const { User, userSchema } = require('./user.class');
const { joiValidateObj } = require('../datastructComponents');

// Create schema
const schema = {
  // orgAdmin specific validation params
  ...userSchema
};

// Define class
class OrgAdmin extends User {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    obj.userType = 'orgAdmin';
    super( obj );
  }
}

exports.OrgAdmin = OrgAdmin;
exports.orgAdminSchema = schema;
